import React from 'react';
import './Banner.css';

const Banner = () => {
    return (
        <div id="hero">
            <div className="hero section-container">
                <div>
                    <h1>Hello, <span></span></h1>
                    <h1>This is <span></span></h1>
                    <h1>Avijit Roy<span></span></h1>
                    <br /><br />
                    <a href="https://drive.google.com/file/d/1-qtS2D4YI6pdX-1lS6IdTmHFXRZ9zFNC/view?usp=sharing" target="_blank" type="button" className="cta" rel="noreferrer">Download Resume</a>
                </div>
            </div>
        </div>
    );
};

export default Banner;